module.exports = __webpack_public_path__ + "20f70760030899e98c4c1d621f2b9dfb.jpg";